/*!
 * Copyright (C) Octillion Media LLC 2019
 * All Rights Reserved.
 */

import {useToast} from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';


import moment from 'moment'
import moment_timezone from 'moment-timezone'
import {putUserApi, getSingleUser} from "./api";
import {DspAuth} from '@octillion/auth';
import autoTable from "jspdf-autotable";

var $toast = useToast();
var fractionDigit = 2;
var minFractionDigit = 0;
var startDefaultTime = {"hour": 0, "minute": 0, "second": 0};
var accountTimeZone = 'UTC';
var ISTTIMEZONE = 'UTC';
export const metabasePublicUrl = 'https://bi.octillion.tv/public/question/';

if (window.localStorage.getItem('user')) {
    let userData = JSON.parse(window.localStorage.getItem('user'));
    if (userData.user && userData.user.timezone) {
        accountTimeZone = userData.user.timezone;
        ISTTIMEZONE = userData.user.timezone;
    }
}
// Create our number formatter.
var formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: fractionDigit,
    minimumFractionDigits: minFractionDigit
});

export function currencyFormatter(value) {
    return formatter.format(value ? value.toFixed(fractionDigit) : 0);
}

export function parseCurrency(value) {
  if (typeof value === 'string') {
    // Remove any non-digit, non-decimal characters
    const numericString = value.replace(/[^0-9.-]+/g, '');
    return parseFloat(numericString);
  }
  return typeof value === 'number' ? value : 0;
}

export function percentageFormatter(value) {
    return value.toFixed(fractionDigit) + '%';
}

export function localStringFormate(value) {
    return value.toLocaleString("en-US", {
        maximumFractionDigits: fractionDigit,
        minimumFractionDigits: minFractionDigit
    })
}

export function toTitleCase(str) {
    return str.replace(
        /\w\S*/g,
        function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        }
    );
}

export function numberFormatter(value, isFractionDigit = false) {
    if (isFractionDigit) {
        return new Intl.NumberFormat('en-US', {
            minimumFractionDigits: fractionDigit,
            maximumFractionDigits: fractionDigit
        }).format(value);
    } else {
        return new Intl.NumberFormat('en-US').format(value);
    }
}

export function removeRefence(Obj) {
    return JSON.parse(JSON.stringify(Obj));
}

export function getVueObject(obj) {
    return JSON.parse(JSON.stringify(obj));
}

export function isNumberValid(n) {
    return /^-?[\d.]+(?:e-?\d+)?$/.test(n);
}

export function moneyFormat(labelValue) {
    // Nine Zeroes for Billions
    return Math.abs(Number(labelValue)) >= 1.0e+9

        ? Math.abs(Number(labelValue)) / 1.0e+9 + "B"
        // Six Zeroes for Millions
        : Math.abs(Number(labelValue)) >= 1.0e+6

            ? (Math.abs(Number(labelValue)) / 1.0e+6).toFixed(2) + "M"
            // Three Zeroes for Thousands
            : Math.abs(Number(labelValue)) >= 1.0e+3

                ? Math.abs(Number(labelValue)) / 1.0e+3 + "K"

                : Math.abs(Number(labelValue));
}

export function numberInAbbr(labelValue, fractionDigit = 2, isUnderthreeDigit = false) {
    // Nine Zeroes for Billions
    return Math.abs(Number(labelValue)) >= 1.0e+12

        ? (Math.abs(Number(labelValue)) / 1.0e+12).toFixed(fractionDigit) + "T"

        : Math.abs(Number(labelValue)) >= 1.0e+9

            ? (Math.abs(Number(labelValue)) / 1.0e+9).toFixed(fractionDigit) + "B"
            // Six Zeroes for Millions
            : Math.abs(Number(labelValue)) >= 1.0e+6

                ? (Math.abs(Number(labelValue)) / 1.0e+6).toFixed(fractionDigit) + "M"
                // Three Zeroes for Thousands
                : Math.abs(Number(labelValue)) >= 1.0e+3

                    ? (Math.abs(Number(labelValue)) / 1.0e+3).toFixed(fractionDigit) + "K"

                    : isUnderthreeDigit ? Math.abs(Number(labelValue)) : Math.abs(Number(labelValue)).toFixed(fractionDigit);
}


export function isNumber(e, isDecimal) {
    let key = e.keyCode || e.charCode;
    var vKey = 86;
    var AKey = 65;
    var cKey = 67;
    if (key == 37 || key == 39) {
        return false;
    } else if (key != 8 && key != 46) {
        const numbers = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"];
        if (vKey == key || AKey == key || cKey == key) {
            return false;
        } else if ((!isDecimal && !numbers.includes(key) || isDecimal && key != 190 && key != 110) && (!e.key.trim() || isNaN(e.key))) {
            e.preventDefault();
            e.stopImmediatePropagation();
            return;
        }
    }
}

export function isDisabledFuture(date) {
    return date > new Date();
}

export function USdateFormat(date, isTime = true) {
    let usDate = utcTimeConvert(date);
    if (isTime) {
        return moment(usDate, ['MM/DD/YYYY, hh:mm:ss A']).format('MM-DD-YYYY HH:mm:ss');
    } else {
        return moment(usDate, ['MM/DD/YYYY, hh:mm:ss A']).format('MM-DD-YYYY');
    }
}

export function slider_impression(daily, hourly, impressions) {
    let impression_result;
    if (daily === 1 && hourly === 1) {
        impression_result = (impressions / 100) * 15
    } else if (daily === 2 && hourly === 1) {
        impression_result = (impressions / 100) * 30
    } else if (daily === 3 && hourly === 1) {
        impression_result = (impressions / 100) * 46
    } else if (daily === 4 && hourly === 1) {
        impression_result = (impressions / 100) * 61
    } else if (daily === 5 && hourly === 1) {
        impression_result = (impressions / 100) * 66
    } else if (daily === 1 && hourly === 2) {
        impression_result = (impressions / 100) * 17
    } else if (daily === 2 && hourly === 2) {
        impression_result = (impressions / 100) * 33
    } else if (daily === 3 && hourly === 2) {
        impression_result = (impressions / 100) * 50
    } else if (daily === 4 && hourly === 2) {
        impression_result = (impressions / 100) * 66
    } else if (daily === 5 && hourly === 2) {
        impression_result = (impressions / 100) * 72
    } else if (daily === 1 && hourly === 3) {
        impression_result = (impressions / 100) * 18
    } else if (daily === 2 && hourly === 3) {
        impression_result = (impressions / 100) * 36
    } else if (daily === 3 && hourly === 3) {
        impression_result = (impressions / 100) * 54
    } else if (daily === 4 && hourly === 3) {
        impression_result = (impressions / 100) * 72
    } else if (daily === 5 && hourly === 3) {
        impression_result = (impressions / 100) * 78
    } else if (daily === 1 && hourly === 4) {
        impression_result = (impressions / 100) * 20
    } else if (daily === 2 && hourly === 4) {
        impression_result = (impressions / 100) * 39
    } else if (daily === 3 && hourly === 4) {
        impression_result = (impressions / 100) * 59
    } else if (daily === 4 && hourly === 4) {
        impression_result = (impressions / 100) * 78
    } else if (daily === 5 && hourly === 4) {
        impression_result = (impressions / 100) * 85
    } else if (daily === 1 && hourly === 5) {
        impression_result = (impressions / 100) * 21
    } else if (daily === 2 && hourly === 5) {
        impression_result = (impressions / 100) * 42
    } else if (daily === 3 && hourly === 5) {
        impression_result = (impressions / 100) * 63
    } else if (daily === 4 && hourly === 5) {
        impression_result = (impressions / 100) * 85
    } else if (daily === 5 && hourly === 5) {
        impression_result = (impressions / 100) * 92
    } else if (daily === 1 && hourly === 6) {
        impression_result = (impressions / 100) * 23
    } else if (daily === 2 && hourly === 6) {
        impression_result = (impressions / 100) * 46
    } else if (daily === 3 && hourly === 6) {
        impression_result = (impressions / 100) * 69
    } else if (daily === 4 && hourly === 6) {
        impression_result = (impressions / 100) * 92
    } else if (daily === 5 && hourly === 6) {
        impression_result = (impressions / 100) * 100
    } else {
        impression_result = impressions;
    }
    return impression_result;
}

export function filterLocation(place, address) {
    let blocked_keyWords = ['Gun Store', 'Pharmacy', 'Cannabis', 'Alcohol', 'Tobacco', 'Medical', 'Clinics'];
    let valueExists = blocked_keyWords.some(item => address.includes(item));
    let blocked_categories = [
        'hospital', 'doctor', 'clinic', 'blood bank', 'medical',
        'pharmacy', 'veterinary', 'health', 'dentist', 'drugstore'
    ];

    // let error = blocked_categories.some(category => place.types.includes(category));
    // Check if place.types exists and is an array, then check for blocked categories
    let error = false;
    if (Array.isArray(place.types)) {
        error = blocked_categories.some(category => place.types.includes(category));
    }

    if (error || valueExists) {
        return true;
    }
}

export function USADisplayDateTimeFormat(date) {
    return moment(date, 'YYYY-MM-DDTHH:mm:ss[Z]').format('MM-DD-YYYY HH:mm:ss');
}

Array.prototype.insert = function (index, item) {
    this.splice(index, 0, item);
};

export function todayDateWithTimezone(formate = 'MM-DD-YYYY') {
    return moment().tz(accountTimeZone).format(formate);
}

export function currentDateWithTimezone() {
    const currentTime = new Date();
    //const convertTime = moment(currentTime).tz('Pacific/Niue').format("YYYY-MM-DD HH:mm:ss");
    const convertTime = moment(currentTime).tz(accountTimeZone).format("YYYY-MM-DD HH:mm:ss");
    return new Date(convertTime);


}


export function returnTimeObj(timeObj = null) {
    let defaultTime = {"hour": 23, "minute": 59, "second": 59};
    if (timeObj) {
        let time = moment(timeObj, 'HH:mm:ss');
        defaultTime.hour = time.get('hour');
        defaultTime.minute = time.get('minute');
        defaultTime.second = time.get('second');
    }
    return defaultTime;
}

export function timeObject(timeString) {
    let time = timeString.split(":");
    return {"hour": time[0], "minute": time[1], "second": time[2]};
}

export function utcTimeConvertStart(date = null) {
  if (date) {
    // return Date object in the target timezone
    const localDate = new Date(date);
    // convert to ISO string in the target timezone
    const tzDateStr = localDate.toLocaleString("en-US", {
      timeZone: accountTimeZone,
    });
    return new Date(tzDateStr); // return as Date object
  } else {
    // set default time using Moment, then convert to ISO string
    const m = moment().set(startDefaultTime);
    return m.toDate(); // Date object
  }
}


export function utcTimeConvert(date = null, onlyTimeString = false) {
    if (onlyTimeString && date) {
        let usDate = utcTimeConvert(date);
        return moment(usDate, ['MM/DD/YYYY, hh:mm:ss A']).format('HH:mm:ss');
    } else if (date) {
        return new Date(date).toLocaleString("en-US", {timeZone: accountTimeZone})
    } else {
        let defaultTime = {"hour": 23, "minute": 59, "second": 59};
        return new Date(moment().set(defaultTime))
    }
}

export function timeZoneDifference(date = null) {
    let currentDate = new Date();
    if (date) {
        currentDate = new Date(date);
    }
    return moment_timezone.tz(currentDate, accountTimeZone).format('Z');
}

//time zone difference end
export function keyConvertIntoFormalName(key) {
    return key !== null && key !== undefined && typeof key === 'string' ? key.split("_").map(ele => {
        return toTitleCase(ele)
    }).join(" ") : key;
}

export function insertIntoIndex(list, index, item) {
    return list.insert(index, item);
}

export function replacePontoUtil(e, cpm = false) {
    var ponto = e.target.value.split('.').length;
    let splitData = e.target.value.split('.');
    let prefix = '';
    if (splitData[0] == '') {
        prefix = 0;
    }

    if (ponto == 2) {
        if (cpm === false) {
            setTimeout(
                function () {
                    if (splitData[0].length > 0) {
                        e.target.value = parseFloat(`${prefix}${e.target.value.substr(0, (e.target.value.indexOf('.') + 3))}`);
                        //e.target.value = parseFloat(`${prefix}.${e.target.value}`);
                    } else {
                        e.target.value = parseFloat(`${prefix}${e.target.value.substr(0, (e.target.value.indexOf('.') + 3))}`);
                    }
                }, 2000);
        } else {
            e.target.value = parseFloat(`${prefix}${e.target.value.substr(0, (e.target.value.indexOf('.') + 3))}`);
        }
    }
}

export function toggleDateSelected(selectedIndex, range = null, isDateOnly = false) {

    let start_date = moment().tz(accountTimeZone).set(startDefaultTime);
    let end_date = moment().tz(accountTimeZone).set(returnTimeObj());
    switch (selectedIndex) {
        case 0:
            start_date.subtract(0, 'days').set(startDefaultTime);
            end_date.subtract(0, 'days').set(returnTimeObj());
            break;
        case 1:
            start_date.subtract(1, 'days').set(startDefaultTime);
            end_date.subtract(1, 'days').set(returnTimeObj());
            break;
        case 2:
            start_date.subtract(2, 'days').set(startDefaultTime);
            end_date.set(returnTimeObj());
            break;
        case 3:
            start_date.subtract(6, 'days').set(startDefaultTime);
            end_date.set(returnTimeObj());
            break;
        case 4:
            start_date.startOf('month').set(startDefaultTime);
            end_date.endOf('month').set(returnTimeObj());
            break;
        case 5:
            start_date = moment('2022-01-01').set(startDefaultTime);
            end_date.set(returnTimeObj());
            break;
        case 6:
            if (range) {
                start_date = moment(range[0]).set(startDefaultTime);
                end_date = moment(range[1]).set(returnTimeObj());
            }
            break;
        default:
            start_date.set(startDefaultTime);
            end_date.set(returnTimeObj());
            break;
    }
    if (isDateOnly) {
        return {
            start_date: start_date.format('YYYY-MM-DDTHH:mm:ss'),
            end_date: end_date.format('YYYY-MM-DDTHH:mm:ss')
        }
    } else {
        return {
            start_date: start_date.format('YYYY-MM-DDTHH:mm:ss') + timeZoneDifference(start_date.format('YYYY-MM-DDTHH:mm:ss')),
            end_date: end_date.format('YYYY-MM-DDTHH:mm:ss') + timeZoneDifference(end_date.format('YYYY-MM-DDTHH:mm:ss'))
        }
    }


}

export function getListOfValues(selectedKey, type) {
    var selectedList = {
        include: [],
        exclude: [],
        require: []
    };
    if (selectedKey && selectedKey.all && selectedKey.all[type] && selectedKey.all[type].any && selectedKey.all[type].any.length > 0) {
        let data = selectedKey.all[type].any.map((ele) => {
            let obj = {...ele};
            if (ele.value_name) {
                obj.list_name = ele.value_name
                obj.list_id = ele.value;
                obj.list_type = type
                return obj
            } else
                return obj.value;
        });
        selectedList.include = data;
    }
    if (selectedKey && selectedKey.all && selectedKey.all[type] && selectedKey.all[type].all && selectedKey.all[type].all.length > 0) {
        let data = selectedKey.all[type].all.map((ele) => {
            let obj = {...ele};
            if (ele.value_name) {
                obj.list_name = ele.value_name
                obj.list_id = ele.value;
                obj.list_type = type
                return obj
            } else
                return obj.value;
        });
        selectedList.require = data;
    }
    if (selectedKey && selectedKey.none && selectedKey.none[type] && selectedKey.none[type].any && selectedKey.none[type].any.length > 0) {
        let data = selectedKey.none[type].any.map((ele) => {
            let obj = {...ele};
            if (ele.value_name) {
                obj.list_name = ele.value_name
                obj.list_id = ele.value;
                obj.list_type = type
                return obj
            } else
                return obj.value;
        });
        selectedList.exclude = data;
    }

    return [...selectedList.exclude, ...selectedList.include, ...selectedList.require].filter((ele) => ele != "" && ele != null);
}


export function merge(a, b, prop) {
    if (a.length > 0) {
        var reduced = a.filter(function (aitem) {
            return !b.find(function (bitem) {
                return aitem[prop] === bitem[prop];
            });
        });
        return reduced.concat(b);
    } else {
        return b;
    }

}


export function customEncode(pictureUrl) {
    var map = {
        '&': '%26',
        '<': '%3c',
        '>': '%3e',
        '"': '%22',
        "'": '%27'
    };

    var encodedPic = encodeURI(pictureUrl);
    var result = encodedPic.replace(/[&<>"']/g, function (m) {
        return map[m];
    });
    return result;
}

export function getPerPage(customPage = 100) {
    const userData = localStorage.getItem('user')
    if (userData) {
        let user = JSON.parse(userData);
        let ui_preferences = Array.isArray(user.user.ui_preferences) ? {} : user.user.ui_preferences;
        if (ui_preferences.page_size) {
            return customPage > 100 ? customPage : ui_preferences.page_size;
        } else {
            return customPage;
        }
    } else {
        //If for some reason someone wanted to test and remove
        //The user information we will need to force reload
        //In order for keycloak js validate actual session 
        localStorage.clear()
        sessionStorage.clear()
        window.location.reload()
    }
}

export function isNumeric(value) {
    return /^\d+$/.test(value);
}

export function updateUserPreferences(pageSize = 10) {
    let user = JSON.parse(localStorage.getItem('user'));
    let ui_preferences = Array.isArray(user.user.ui_preferences) ? user.user.ui_preferences[0] : user.user.ui_preferences;
    let payload = {
        id: user.user.uuid,
        ui_preferences: {...ui_preferences, ...{page_size: pageSize}},
        account_id: user.user.alt_account_id,
    };
    let arrayObj = ["first_name", "last_name", "email", "role_id"];
    arrayObj.forEach(element => {
        payload[element] = user.user[element];
    });

    putUserApi(payload).then((response) => {

        // getSingleUser(user.uuid).then(result => {
        //     let finalUserSet = Object.assign(user, {ui_preferences: result.data.ui_preferences});
        //    // user.user = finalUserSet; 
        //     localStorage.setItem('user', JSON.stringify(finalUserSet));
        // });
        // return response;
    })
}

export function getUserPreferences() {
    let user = JSON.parse(localStorage.getItem('user'));
    let ui_preferences = Array.isArray(user.user.ui_preferences) ? user.user.ui_preferences[0] : user.user.ui_preferences;
    return ui_preferences;
}

export function getUserPermissions(permissionName) {

    const auth = DspAuth.getInstance()
    const user = auth.getUser()
    if (user && user.isLoggedIn()) {
        return user.getResourceScopes(permissionName)
    }

    let userPermissionVal;
    let userData = JSON.parse(localStorage.getItem('user'));
    let userPermissions = userData?.user?.permissions

    if (userPermissions) {
        for (const key in userPermissions) {
            if (key === permissionName) {
                userPermissionVal = userPermissions[key];
            }
        }

    }
    return getUserPermissionsName(userPermissionVal)

}

export function getUserPermissionsName(userPermissionVal) {
    switch (userPermissionVal) {
        case 1:
            return ['read'];
        case 2:
            return ['write'];
        case 3:
            return ['read', 'write'];
        case 4:
            return ['update'];
        case 5:
            return ['read', 'update'];
        case 6:
            return ['write', 'update'];
        case 7:
            return ['read', 'write', 'update'];
        case 8:
            return ['delete'];
        case 9:
            return ['read', 'delete'];
        case 10:
            return ['write', 'delete'];
        case 11:
            return ['read', 'write', 'delete'];
        case 12:
            return ['update', 'delete'];
        case 13:
            return ['read', 'update', 'delete'];
        case 14:
            return ['update', 'write', 'delete'];
        case 15:
            return ['read', 'write', 'update', 'delete'];
        default:
            return [];
    }

}

export function getUserRoleGroups() {
    let user = JSON.parse(localStorage.getItem('user'));
    return user.user.groups || [];
}

export function getRoleNamebyID(id, allRoles) {
    let filterRole = {}
    if (allRoles && allRoles.length > 0)
        filterRole = allRoles.find(e => e.role_id === id)
    return filterRole?.name ? filterRole?.name : 'N/A'
}


export function validateZipCode(zipCode) {
    let codeListRegex = /^(?:[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ]\d[ABCEGHJKLMNPRSTVWXYZ]\d|\d{4,5}(?:[-\s]\d{4})?)(?:,\s*(?:[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ]\d[ABCEGHJKLMNPRSTVWXYZ]\d|\d{4,5}(?:[-\s]\d{4})?))*$/i;
    return codeListRegex.test(zipCode)
}

export function duplicateValidate(iterable) {
    return new Set(iterable).size !== iterable.length;
}

export function randomString(length, chars) {
    let mask = '';
    let result = '';
    if (chars.indexOf('a') > -1) mask += 'abcdefghijklmnopqrstuvwxyz';
    if (chars.indexOf('A') > -1) mask += 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    if (chars.indexOf('#') > -1) mask += '0123456789';
    if (chars.indexOf('!') > -1) mask += '!@#$%^&*';
    for (let i = length; i > 0; --i) result += mask[Math.round(Math.random() * (mask.length - 1))];
    return result;
}

export function getDateRange(start_date, end_date) {
    var date_range = [];
    var current_date = new Date(start_date);
    var end = new Date(end_date);
    while (current_date <= end) {
        let date = moment(current_date).format('MM-DD-YYYY');
        date_range.push(date);
        current_date.setDate(current_date.getDate() + 1);
    }
    return date_range;
}

export function OSIIconClass(osi) {

    if (osi < 80) {
        return 'bx-trending-down';
    } else if (osi > 80 && osi <= 95) {
        return 'bx-down-arrow-alt';
    } else if (osi > 95 && osi <= 105) {
        return 'bx-transfer-alt';
    } else if (osi > 105 && osi <= 120) {
        return 'bx-up-arrow-alt';
    } else {
        return 'bx-trending-up';
    }
}

export function OSITextColorClass(osi) {
    if (osi < 80) {
        return 'text-danger';
    } else if (osi > 80 && osi <= 95) {
        return 'text-warning';
    } else if (osi > 95 && osi <= 105) {
        return 'text-success';
    } else if (osi > 105 && osi <= 120) {
        return 'text-warning';
    } else {
        return 'text-danger';
    }
}

export function domainWithoutHttps(value) {
    if (!value || value.trim() === '') {

        return true;
    }

    const domains = value.split(',').map(domain => domain.trim());
    // eslint-disable-next-line
    const regex = /^(?!http:\/\/|https:\/\/)[a-zA-Z0-9\-]+(\.[a-zA-Z0-9\-]+)*(\.[a-zA-Z]{2,})$/;
    let isValid = domains.every(domain => regex.test(domain));

    return isValid

}

export function checkEmailsError(value) {

    if (!value || value?.trim() === '' || value == '' || value == null) {
        return false;
    }
    const emails = value.split(',').map(email => email.trim());
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    let isValid = emails.every(email => regex.test(email));
    return !isValid

}

export function debounce(func, wait) {
    let timeout;
    return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            func.apply(this, args);
        }, wait);
    };
}


// dsp 360 dashboard function 

export function permissionFlagAlert(user, section, type, redirectUrl) {
    let users = user;
    let userRights = users && users.userdetails && users.userdetails.user_rights ? users.userdetails.user_rights : {};
    if (!getRigthsCondition(userRights, section, type)) {
        //   Swal.fire({
        //     title: "Permission",
        //     text: `You don't have permission access this page`,
        //     icon: "warning",
        //     showCancelButton: false,
        //     confirmButtonColor: "#34c38f",
        //     cancelButtonColor: "#f46a6a",
        //     confirmButtonText: "Home",
        //   }).then((result) => {
        //     if (result.value) {
        //       window.location.href = redirectUrl;
        //     }
        //   });
    }
}

export function storeToLocalStorage(obj, type = 'dashboards') {
    let dashboards = localStorage.getItem(type) ? JSON.parse(localStorage.getItem(type)) : [];
    dashboards.push(obj);
    localStorage.setItem(type, JSON.stringify(dashboards));
}

export function getDashboards(type = 'dashboards') {
    let dashboards = localStorage.getItem(type) ? JSON.parse(localStorage.getItem(type)) : [];
    return dashboards;
}

export function getSlugByDashboard(hash, type = 'dashboards') {
    let dashboards = localStorage.getItem(type) ? JSON.parse(localStorage.getItem(type)) : [];
    return dashboards.find(ele => ele.hashCode == hash);
}

export function getSlugNameByDashboard(hash, type = 'dashboards') {
    let dashboards = localStorage.getItem(type) ? JSON.parse(localStorage.getItem(type)) : [];
    return dashboards.find(ele => ele.slug == hash);
}


export function updateToLocalStorage(obj, hash, type = 'dashboards') {
    let dashboards = localStorage.getItem(type) ? JSON.parse(localStorage.getItem(type)) : [];
    let index = dashboards.findIndex(ele => ele.hashCode == hash);
    dashboards[index] = {
        ...obj, ...{hashCode: hash}
    }
    localStorage.setItem(type, JSON.stringify(dashboards));
}

export function removeDashboardObject(dashboards, type = 'dashboards') {
    localStorage.setItem(type, JSON.stringify(dashboards));
}

export function monthStartDateWithEST() {
    const currentMonthData = moment().startOf('month').set({"hour": 0, "minute": 0, "second": 0}).format("YYYY-MM-DDTHH:mm:ss");
    let convertTime = currentMonthData + moment_timezone.tz(currentMonthData, ISTTIMEZONE).format('Z');
    return convertTime;
}


export function getRigthsCondition(object, type, method) {
    return object && object[type] && object[type][method] ? object[type][method] : false;
}

function htmlDecode(input) {
    var doc = new DOMParser().parseFromString(input, "text/html");
    return doc.documentElement.textContent;
}

export function customFilterIds(array, mappedData = {}) {
    let Obj = {};
    array.forEach(element => {
        let keyExist = element.value; 
        if(mappedData[element.value]) {
            keyExist = mappedData[element.value];
        }
        Obj[keyExist] = element.data.map(ele => ele[element.key]).join(",");
    });
    return Obj;
}

export function toastMsg(msg, functionName, duration = 8000, position = "bottom") {
    $toast[functionName](msg, {
        theme: "toasted-primary",
        position: position,
        iconPack: 'material',
        duration: duration,
    });
}


export function convertToAMPM(numStr) {
    // Parse the input string to an integer
    const num = parseInt(numStr, 10);

    if (isNaN(num) || num < 0 || num > 23) {
        return "Invalid input";
    } else if (num == 0) {
        return "MID";
    } else if (num < 12) {
        return numStr + " AM";
    } else if (num === 12) {
        return "12 PM";
    } else {
        return (num - 12) + " PM";
    }
}

export function filterArray(arr, filter) {
    return arr.filter(obj => {
        return Object.keys(filter).every(key => {
            if (typeof obj[key] === 'string' && typeof filter[key] === 'string') {
                return obj[key].toLowerCase().includes(filter[key].toLowerCase());
            } else {
                return obj[key] === filter[key];
            }
        });
    });
}

// Test the function with the range -50 to 80
const minRange = -50;
const maxRange = 80;

export function generateRandomPerInRange(min, max) {
    const range = max - min + 1;
    const randomNumber = Math.floor(Math.random() * range) + min;
    return String(randomNumber);
}

export function percentageValue(number, percentage) {
    let withOutSign = Math.abs(percentage)
    if (percentage < 0) {
        return number - (number * withOutSign / 100);
    } else {
        return number + (number * withOutSign / 100)
    }
}

// force the domain of the email to be lowercase and send it to the email validator
export const emailFormatter = (value) => {
    if (!value) return value;
    let parts = value.split('@');
    parts[1] = parts[1].toLowerCase();
    return parts.join('@');
}


export const getDevidedItemIntoWidth = (objects) => {
    // const maxWidth = 12;
    // let rows = [];
    // let currentRow = [];
    // let currentWidth = 0;

    // for (let obj of objects) {
    //     if (currentWidth + obj.w > maxWidth) {
    //         // If adding the current object exceeds maxWidth, push the current row to rows and start a new row
    //         rows.push(currentRow);
    //         currentRow = [];
    //         currentWidth = 0;
    //     }

    //     // Add the object to the current row
    //     currentRow.push(obj);
    //     currentWidth += obj.w;
    // }

    // // Push the last row if it's not empty
    // if (currentRow.length > 0) {
    //     rows.push(currentRow);
    // }

    // return rows;   

    // Implement this method to divide items into rows based on their width
    // This is important for calculating where the next item should be placed
    // Example:
    let rows = [];
    let currentRow = [];
    let currentWidth = 0;

    objects.forEach(item => {
        if (currentWidth + item.w > 12) {
            rows.push(currentRow);
            currentRow = [];
            currentWidth = 0;
        }
        currentRow.push(item);
        currentWidth += item.w;
    });

    if (currentRow.length > 0) {
        rows.push(currentRow);
    }

    return rows;
}

export const getMaxCountElement = (arr) => {
    return arr.reduce((a, b, i, arr) =>
        arr.filter(v => v === a).length >= arr.filter(v => v === b).length ? a : b
    );
}

export const getPolygonCentroid = (points) => {
    let centroidX = 0, centroidY = 0;
    let signedArea = 0;
    let x0 = 0; // Current vertex X
    let y0 = 0; // Current vertex Y
    let x1 = 0; // Next vertex X
    let y1 = 0; // Next vertex Y
    let a = 0;  // Partial signed area

    // For all vertices except last
    for (let i = 0; i < points.length - 1; i++) {
        x0 = points[i][0];
        y0 = points[i][1];
        x1 = points[i + 1][0];
        y1 = points[i + 1][1];
        a = x0 * y1 - x1 * y0;
        signedArea += a;
        centroidX += (x0 + x1) * a;
        centroidY += (y0 + y1) * a;
    }

    // Do last vertex separately to complete the loop
    x0 = points[points.length - 1][0];
    y0 = points[points.length - 1][1];
    x1 = points[0][0];
    y1 = points[0][1];
    a = x0 * y1 - x1 * y0;
    signedArea += a;
    centroidX += (x0 + x1) * a;
    centroidY += (y0 + y1) * a;

    signedArea *= 0.5;
    centroidX = (centroidX / (6 * signedArea));
    centroidY = (centroidY / (6 * signedArea));

    return [centroidX, centroidY];
}

// Function to calculate the centroid of a polygon
export const calculatePolygonCenter = (vertices) => {
    let centroidLat = 0;
    let centroidLng = 0;

    // Calculate centroid coordinates
    vertices.forEach(vertex => {
        centroidLat += vertex.lat;
        centroidLng += vertex.lng;
    });

    centroidLat /= vertices.length;
    centroidLng /= vertices.length;

    return {lat: centroidLat, lng: centroidLng};
}

export const getArrayDepth = (arr) => {
    if (!Array.isArray(arr)) return 0;
    let maxDepth = 0;
    arr.forEach(item => {
        if (Array.isArray(item)) {
            const itemDepth = getArrayDepth(item);
            if (itemDepth > maxDepth) {
                maxDepth = itemDepth;
            }
        }
    });
    return maxDepth + 1;
}

export const objectToFormData = (obj, form = new FormData(), namespace = '') => {
    for (let key in obj) {
        if (!Object.hasOwn(obj, key)) continue;
        let formKey = namespace ? `${namespace}[${key}]` : key;
        if (Array.isArray(obj[key])) {
            for (const item of obj[key]) {
                form.append(key, item);
            }
        }
        // Check if the property is an object and not a file
        else if (typeof obj[key] === 'object' && !(obj[key] instanceof File)) {
            objectToFormData(obj[key], form, formKey);
        } else {
            form.append(formKey, obj[key]);
        }
    }
    return form;
}


export const getColor = (position, total) => {
    const hue = (1 - position / total) * 120; // From red (0) to green (120)
    return `hsl(${hue}, 100%, 50%)`;
}

export function percentageToColor(perc) {
    let r, g, b = 0;
    if (perc < 50) {
        r = 255;
        g = Math.round(5.1 * perc);
    } else {
        g = 255;
        r = Math.round(510 - 5.10 * perc);
    }
    let h = r * 0x10000 + g * 0x100 + b * 0x1;
    return '#' + ('000000' + h.toString(16)).slice(-6);
}

export function getPolygonsBounds(polygons) {
    const google = window.google
    let bounds = new google.maps.LatLngBounds();
    for (let j = 0; j < polygons.length; j++) {
        for (let i = 0; i < polygons[j].paths.length; i++) {
            bounds.extend(polygons[j].paths[i]);
        }
    }
    return bounds;

}

export function buildPolygons(polygonsData, censusData) {
    let polygonsArr = []
    polygonsData.forEach(function (parseObj) {
        let fill_color = "";
        let censusObjIndex = censusData.findIndex(element => element.zip_code === parseObj.properties.zipCode);
        let censusObj = censusData[censusObjIndex];
        if (censusObj) {
            fill_color = percentageToColor(censusObj.percentage);

        } else {
            fill_color = percentageToColor(Math.floor((Math.random() * 100) + 1));
        }
        let combineMap = [];
        if (parseObj.geometry.coordinates && parseObj.geometry.type === "Polygon") {
            parseObj.geometry.coordinates.forEach(e => {
                combineMap = [...combineMap, ...e];
            });
            parseObj.path = combineMap.map(element => {
                return {lat: element[1], lng: element[0]}
            });
            let Obj = {
                properties: parseObj.properties,
                paths: parseObj.path,
                options: {
                    strokeColor: "#000000",
                    strokeOpacity: 0.5,
                    strokeWeight: 1,
                    fillColor: fill_color,
                    fillOpacity: 0.7,
                    geodesic: false,
                }

            }
            polygonsArr.push(Obj);
        } else if (parseObj.geometry.coordinates && parseObj.geometry.type === "MultiPolygon") {
            parseObj.geometry.coordinates.forEach(ele => {
                ele.forEach(e => {
                    parseObj.path = e.map(element => {
                        return {lat: element[1], lng: element[0]}
                    });
                    let Obj = {
                        properties: parseObj.properties,
                        paths: parseObj.path,
                        options: {
                            strokeColor: "#000000",
                            strokeOpacity: 0.5,
                            strokeWeight: 1,
                            fillColor: fill_color,
                            fillOpacity: 0.7,
                            geodesic: false,
                        }
                    }
                    polygonsArr.push(Obj);
                });

            });
        }
    });
    return polygonsArr
}


export function forecastProposalPDFGenerate(pdf, forecastDetail, segmentTree, downloadType, pdfFooterLogo, selectedLogo) {
    let octillion_base64 = "data:image/png;base64,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";
    let liveramp_base64 = "data:image/png;base64,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";
    let cadent_base64 = "data:image/png;base64,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";
    let usersIcon = "data:image/png;base64,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";
    selectedLogo = (selectedLogo === null) ? octillion_base64 : selectedLogo;
    let totalPages = pdf.internal.getNumberOfPages()
    pdf.addPage();
    pdf.setPage(totalPages + 1)
    // Set font and font size
    pdf.setFont('Helvetica', 'normal');
    pdf.setFontSize(12);

    let targetingData = [];

    if (forecastDetail.dma_name.length > 0) {
        let obj = {
            title: 'DMA',
            data: [forecastDetail.dma_name.toString().replace(/,/g, ", ")],
        };
        targetingData.push(obj)
    } else if (forecastDetail.congressional_district.length > 0) {

        let obj = {
            title: 'Congressional Districts',
            data: [forecastDetail.congressional_district.toString().replace(/,/g, ", ")],
        };
        targetingData.push(obj)
    } else if (forecastDetail.county_name.length > 0) {
        let obj = {
            title: 'County',
            data: [forecastDetail.county_name.toString().replace(/,/g, ", ")],
        };
        targetingData.push(obj)
    } else if (forecastDetail.state !== '') {
        if (typeof forecastDetail.state === 'string') {
            forecastDetail.state = forecastDetail.state.split(", ");
        }
        let geoStates = forecastDetail.state.map(ele => {
            return ele;
        });
        let obj = {
            title: 'States',
            data: [geoStates.toString().replace(/,/g, ", ")],
        };
        targetingData.push(obj)
    } else if (forecastDetail.specific_address_list.length > 0) {

        let addressArr = forecastDetail.specific_address_list.map(ele => {
            return `${ele.address}  (${ele.radius})`;
        });
        let obj = {
            title: 'Specific Locations',
            data: addressArr,
        };
        targetingData.push(obj)
    } else if (forecastDetail.specific_zip_codes.length === 0) {
        let obj = {
            title: 'National Level',
            data: ['United States Of America'],
        };
        targetingData.push(obj)
    }

    if (forecastDetail.specific_zip_codes.length > 0) {
        let obj = {
            title: 'Specific Zipcodes',
            data: [forecastDetail.specific_zip_codes.toString().replace(/,/g, ", ")],
        };
        targetingData.push(obj)
    }
    if (forecastDetail.remove_zip_codes.length > 0) {
        let obj = {
            title: 'Removed Zipcodes',
            data: [forecastDetail.remove_zip_codes.toString().replace(/,/g, ", ")],
        };
        targetingData.push(obj)
    }


    let startY = 30;
    pdf.setFillColor(0, 163, 229);
    pdf.rect(20, startY, 555, 20, 'F');
    pdf.setTextColor(255, 255, 255);
    pdf.text('Target Markets / Market Areas', 250, (startY + 15));
    startY += 20;


    targetingData.forEach(item => {
        autoTable(pdf, {
            startY: startY,
            margin: {left: 20},
            tableWidth: 555,
            head: [[{content: item.title, colSpan: 2}]],
            body: item.data.map(detail => [detail]),
            theme: 'striped',
            headStyles: {
                fillColor: [215, 215, 215],
                textColor: [0, 0, 0],
            },
            bodyStyles: {
                textColor: [0, 0, 0],
            },
            alternateRowStyles: {
                fillColor: [240, 240, 240],
            },
        });
        startY = pdf.lastAutoTable.finalY;
    });




    let segmentsData = [];
    let octillion = segmentTree[0]['data'];
    let liveRamp = segmentTree[1]['data'];
    let cadent = segmentTree[2]['data'];
    ////segment start

    if (octillion.length > 0 || liveRamp.length > 0 || cadent.length > 0 || segmentTree[3]['data'].length > 0) {
        if (startY > 350) {
            totalPages = pdf.internal.getNumberOfPages()
            pdf.addPage();
            pdf.setPage(totalPages + 1)
            startY = 30;
        } else {
            startY += 50;
        }
        if (downloadType === 'partial') {
            if (octillion.length > 35) {
                let length = octillion.length
                octillion = octillion.slice(0, 35)
                octillion.push({name: `>>>>>>>> ${length - 35} More Octillion Segment <<<<<<<<`})
            }
            if (liveRamp.length > 35) {
                let length = liveRamp.length;
                liveRamp = liveRamp.slice(0, 35)
                liveRamp.push({name: `>>>>>>>> ${length - 35} More LiveRamp Segment <<<<<<<<`})
            }
            if (cadent.length > 35) {
                let length = cadent.length;
                cadent = cadent.slice(0, 35)
                cadent.push({name: `>>>>>>>> ${length - 35} More Cadent Segment <<<<<<<<`})
            }
        }

        if (octillion.length > 0) {
            segmentsData.push({
                segment: 'Octillion Segments',
                logo: octillion_base64,
                subData: octillion,
            })
        }
        if (liveRamp.length > 0) {
            segmentsData.push({
                segment: 'LiveRamp Segments',
                logo: liveramp_base64,
                subData: liveRamp,
            })
        }
        if (cadent.length > 0) {
            segmentsData.push({
                segment: 'Cadent Segments',
                logo: cadent_base64,
                subData: cadent,
            })
        }
        if (segmentTree[3]['data'].length > 0) {
            segmentsData.push({
                segment: 'Segments Group',
                logo: usersIcon,
                subData: segmentTree[3]['data'],
            })
        }

        pdf.setFillColor(0, 163, 229);
        pdf.rect(20, startY, 555, 20, 'F');
        pdf.setTextColor(255, 255, 255);
        pdf.text('Selected Segments', 250, (startY + 15));
        startY += 20;

        /*segmentsData.forEach(item => {
            autoTable(pdf, {
                startY: startY,
                margin: {left: 20},
                tableWidth: 555,
                head: [[{content: '', colSpan: 2}]],
                body: item.subData.map(detail => [detail.name]),
                theme: 'striped',
                headStyles: {
                    fillColor: [215, 215, 215],
                    textColor: [0, 0, 0],
                },
                bodyStyles: {
                    textColor: [0, 0, 0],
                },
                alternateRowStyles: {
                    fillColor: [240, 240, 240],
                },
                didDrawCell: (data) => {
                    if (data.section === 'head' && data.row.index === 0) {
                        const logo = item.logo;
                        const segmentText = item.segment;
                        const textOffsetX = data.cell.x + 25;
                        const textOffsetY = data.cell.y + 14;
                        if (logo) {
                            pdf.addImage(logo, 'PNG', data.cell.x + 7, data.cell.y + 5, 10, 10);
                        }
                        pdf.text(segmentText, textOffsetX, textOffsetY);
                        data.cell.text = '';
                    }
                },
            });
            startY = pdf.lastAutoTable.finalY;
        });*/


    }

    if (pdfFooterLogo) {
        pdf.text('Powered By:', (pdf.internal.pageSize.getWidth() - 570), (pdf.internal.pageSize.getHeight() - 30));
        pdf.addImage(octillion_base64, 'PNG', (pdf.internal.pageSize.getWidth() - 495), (pdf.internal.pageSize.getHeight() - 45), 20, 20);
    }

}

export function currentDateWithZeroTimeTimezone() {
    const currentTime = new Date();
    //const convertTime = moment(currentTime).tz('Pacific/Niue').format("YYYY-MM-DD HH:mm:ss");
    const convertTime = moment(currentTime).tz(accountTimeZone).set({"hour": 0, "minute": 0, "second": 0}).format("YYYY-MM-DD HH:mm:ss");
    return new Date(convertTime);
}

export function sortByName(array) {
    let sortByData =  array.slice().sort((a, b) => {
        const nameA = a.name.toUpperCase(); // ignore upper and lowercase
        const nameB = b.name.toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }

        // names must be equal
        return 0;
    });
    return sortByData;
}

export function dateWithUTCTimezone(date, formate = 'MM-DD-YYYY') {
    return moment(date).tz('UTC').format(formate);
}

export function dateFormate(date, formate = 'MM-DD-YYYY') {
    return moment(date).format(formate);
}

export function dateWithTimezone(date, formate = 'MM-DD-YYYY') {
    return moment(date).tz(accountTimeZone).format(formate);
}

export function isIntValid(n) {
    return /^\d+$/.test(n);
}

export function getBroadcastWeek(momentDate) {
    let date = momentDate.clone();
    let day = date.day();

    // Find the closest Monday <= the date
    let start = moment(date).subtract((day + 6) % 7, 'day').format("MM-DD-YYYY");

    // Find the closest Sunday >= the date
    let end = moment(date).add((7 - day) % 7, 'day');

    return { start, end };
}

export function getBroadcastMonth(momentDate) {
    // Given the start of the Gregorian month is always included in the start of the
    // broadcast month, we can use the broadcast week method to find it.
    let startDate = momentDate.utc().clone().startOf('month');

    // The broadcast end date in the month is always the last Sunday of the month
    let endDate = momentDate.utc().clone().endOf('month');

    let { start } = getBroadcastWeek(startDate);
    let end = endDate.subtract(endDate.day(), 'day').format("MM-DD-YYYY");

    return { start, end };
}

export function isLiveAdmin() {
    const userGroups = getUserRoleGroups();
    const groupNames = userGroups.map(group => group.name);
    const hasLiveAdmin = groupNames.includes('Live Admin');
    return hasLiveAdmin;
}
